/**
 * @generated SignedSource<<c000a4cef6ece8e66da4417f282222dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LogoBlock_contentBlock$data = {
  readonly captionText: string | null | undefined;
  readonly captionTitle: string | null | undefined;
  readonly isQuote: boolean;
  readonly logoAltText: string;
  readonly logoUrl: string;
  readonly " $fragmentType": "LogoBlock_contentBlock";
};
export type LogoBlock_contentBlock$key = {
  readonly " $data"?: LogoBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"LogoBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LogoBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoAltText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "captionTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "captionText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isQuote",
      "storageKey": null
    }
  ],
  "type": "LogoBlock",
  "abstractKey": null
};

(node as any).hash = "cb1c31b4c27941f9e7732b6b16a81b24";

export default node;
